import { extendObservable } from "mobx";

//Mobx Store for Users

class UserStore {
  constructor() {
    extendObservable(this, {
      loading: true,
      isLoggedIn: false,
      userID: -1,
      permissions: [{ name: "visitor" }],
      username: "",
    });
  }
}

export default new UserStore();
